import { Component, OnInit, OnChanges, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ProjectService } from '../../../../../services/project.service';
import { GroupsHelper } from '../../../../../services/core.groups.helper';
import { UiService } from '../../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../../services/core.translate.service';
import { doGetPromise } from '../../../../../config/core.httpclient-utils';
import { UserRest } from '../../../../../services/core.user.rest.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'project-admin-group-edit',
  template: require('./project.admin.group.edit.html')
})
export class ProjectAdminGroupEditComponent implements OnInit, OnChanges {
  loading = false;
  @Input() project: any;
  @Input() group: any;

  @Output() onClose = new EventEmitter<any>();
  @Output() onEdit = new EventEmitter<any>();

  errors: any;
  addUser: any = {};

  constructor(
    private http: HttpClient,
    private projectService: ProjectService,
    private groupsHelper: GroupsHelper,
    private uiService: UiService,
    private translateService: GfTranslateService,
    private stateService: StateService,
    private userRest: UserRest,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.group && changes.group.currentValue) {
      this.groupsHelper.setUnixNameSections(this.group);
    }
  }

  ngOnInit(): void {
    this.errors = this.groupsHelper.resetErrors();
    this.addUser = {
      search: '',
      searchItemsResult: []
    };
    if (this.group) {
      this.groupsHelper.setUnixNameSections(this.group);
    }
  }

  deleteGroupUser(user: any): void {
    const index = _.findIndex(this.group.users, (item: any) => item.id === user.id);
    this.group.users.splice(index, 1);
  }

  searchUser(): void {
    this.addUser.searchItemsResult = [];
    if (this.addUser.search.length < 3) {
      return;
    }
    this.addUser.searching = true;
    const params = {
      q: this.addUser.search,
      s: 'user',
      page_num: 1,
      page_size: 20
    };
    doGetPromise(this.http, '/api/search/', params)
      .then((response: any) => {
        let items = _.sortBy(_.get(response, 'items', []), ['matchScore', 'title']).reverse();
        _.remove(items, currentObject => currentObject.project === 'true');
        this.addUser.searchItemsResult = items;
        this.addUser.searching = false;
      })
      .catch(() => {
        const errorMsg = this.translateService.translate('Sorry, {{searchValue}} does not exist', { searchValue: this.addUser.search });
        const errorMsgTitle = this.translateService.translate('Invalid User');
        this.uiService.message.showWarning(errorMsg, errorMsgTitle);
        this.addUser.searching = false;
        this.addUser.search = '';
      });
  }

  userAdd(item: any): void {
    this.errors = this.groupsHelper.resetErrors();
    this.addUser.search = '';
    this.addUser.searchItemsResult = [];
    if (!this.group.users) {
      this.group.users = [];
    }
    const unixName = item.refId;
    if (_.findIndex(this.group.users, { unixName }) !== -1) {
      return;
    }
    this.userRest.getBasic(unixName).then((user: any) => {
      this.group.users.splice(0, 0, user);
    });
  }

  addUserAutoSubmit(searchValue: string): void {
    if (this.addUser.autoSubmitTimer) {
      clearTimeout(this.addUser.autoSubmitTimer);
    }
    this.addUser.autoSubmitTimer = setTimeout(() => {
      this.searchUser();
    }, 750);
  }

  formatUnixName(): void {
    this.group.unixNameSuffix = _.get(this, 'group.unixNameSuffix', '').toLowerCase().replace(/\s/, '');
    this.errors.unixName.hasError = _.isEmpty(this.group.unixNameSuffix);
  }

  updateGroup(): void {
    if (!this.groupsHelper.validateGroup(this.group, this.errors)) {
      this.uiService.message.showError('User group validation failed', 'Edit Group');
      return;
    }
    const lastUnixName = this.group.unixName;
    this.group.unixName = this.group.unixNameSuffix;
    if (this.group.unixNamePrefix !== '') {
      this.group.unixName = this.group.unixNamePrefix + '-' + this.group.unixNameSuffix.toLowerCase();
    }
    const _group = _.cloneDeep(this.group);
    let _users: any[] = [];
    if (!Array.isArray(_group.users)) {
      _group.users = [];
    }
    for (let i = 0; i < _group.users.length; i++) {
      const user = _group.users[i];
      if (_.findIndex(_users, { id: user.id }) === -1) {
        _users.push({ id: user.id });
      }
    }
    const params = {
      group_id: _group.id,
      name: _group.name,
      unixName: _group.unixName,
      user_ids: (_users.map((item) => item.id)).join(','),
      users: _users
    };
    this.projectService.putGroup(this.project.unixName, lastUnixName, params)
      .then((response: any) => {
        this.uiService.message.showSuccess('Group successfully updated', 'Edit group');
        this.onEdit.emit(response);
      })
      .catch((response: any) => {
        if ('unixName' in response.error && response.error.unixName[0].exception === 'changed') {
          this.uiService.message.showError('Unix name ' + _group.unixName + ' already exists');
        } else {
          this.uiService.message.showError('There was an error trying to update the group', 'Edit Group');
        }
        this.onClose.emit();
      });
  }

  doClose() {
    this.onClose.emit();
  }

  trackById(index: number, item: any): any {
    return item?.id ?? item;
  }
}
